"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getObjectKeys_1 = require("../jsUtils/getObjectKeys");
/**
 * Set styles to an HTML element. If styles are empty, remove 'style' attribute
 * @param element The element to set styles
 * @param styles The styles to set, in name-value pair format
 */
function setStyles(element, styles) {
    if (element) {
        var style = (0, getObjectKeys_1.default)(styles || {})
            .map(function (name) {
            var value = styles[name];
            var trimmedName = name ? name.trim() : null;
            var trimmedValue = value ? value.trim() : null;
            return trimmedName && trimmedValue ? trimmedName + ":" + trimmedValue : null;
        })
            .filter(function (x) { return x; })
            .join(';');
        if (style) {
            element.setAttribute('style', style);
        }
        else {
            element.removeAttribute('style');
        }
    }
}
exports.default = setStyles;
//# sourceMappingURL=setStyles.js.map